import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ScheduleDto from "../../../dto/ScheduleDto";
import ScheduleEntity from "../../../../domain/entities/ScheduleEntity";

const GetSchedulesByDateAndStablishmentApiImpl = async (stablishmentId: string, day: Date): Promise<Either<ErrorEntity, ScheduleEntity[]>> => {
    try {
        const relativeUrl: string = `/schedules/available?stablishment_id=${stablishmentId}&date=${day.toISOString().split("T")[0]}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = ScheduleDto.fromJSONArray(response.available_schedules);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default GetSchedulesByDateAndStablishmentApiImpl;